import * as kea from "kea-react";
import * as React from "react";

import * as models from "app/models/requireme";
import { Estado, Municipio, Ciudad } from "../../simples";
import { componentToRx } from "react-rxk";

import { Ids, filtrarListas, sugerirValores } from "./logic";
import { omitUndefined, omit, enumObject, all } from "keautils";

export interface EstadoMunicipioCiudadValue {
    estado?: number | null;
    municipio?: number| null;
    ciudad?: number| null;
}

interface Props extends kea.FormEditProps<EstadoMunicipioCiudadValue, EstadoMunicipioCiudadValue> {
    listas?: models.Ubicaciones;
    loading?: boolean;
}

function obtenerDatos(props: Props, state: Ids) {
    const ids = ({ ...state, ...omitUndefined(props.value) });
    const datos = filtrarListas(ids, props.listas || {ciudad: [], estado: [], municipio: []});
    const sugerencias = sugerirValores(datos);

    return { ids, datos, sugerencias }
}

class EstadoMunicipioCiudadNoRx extends React.PureComponent<Props> {
    private onEstadoChange = (x: number) => {
        this.handleChange({ estado: x, municipio: undefined, ciudad: undefined });
    }
    private onMunicipioChange = (x: number) => {
        this.handleChange({ municipio: x });
    }
    private onCiudadChange = (x: number) => {
        this.handleChange({ ciudad: x });
    }

    private handleChange = (valueChange: Partial<Ids>) => {
        const fueQuitar = all(enumObject(valueChange).map(x => x.value), x => x == null);

        const nextValue = { ... this.props.value, ...valueChange };
        const nextProps = { ... this.props, value: nextValue };
        //Si el usuario le quito valores no metemos la sugerencia:
        const sugerencias = fueQuitar ? {} : obtenerDatos(nextProps, {}).sugerencias;

        //No sugerimos de los valores que estamos cambiando
        const sugerenciasFiltradas = omit(sugerencias, Object.keys(valueChange) as any[]);
        if (this.props.onChange)
            this.props.onChange({ ...nextValue, ...sugerenciasFiltradas });
    }


    render() {
        const { datos, ids } = obtenerDatos(this.props, {});
        const { loading, readonly } = this.props;
        return (
            kea.autogrid(4, [
                <Estado label="Estado" items={datos.estado} value={ids.estado} onChange={this.onEstadoChange} loading={loading} readonly={readonly} />,
                <Municipio label="Municipio" items={datos.municipio} value={ids.municipio} onChange={this.onMunicipioChange} loading={loading} readonly={readonly} />,
                <Ciudad label="Ciudad" items={datos.ciudad} value={ids.ciudad} onChange={this.onCiudadChange} loading={loading} readonly={readonly} />
            ])
        );
    }
}

export const EstadoMunicipioCiudad = componentToRx(EstadoMunicipioCiudadNoRx, undefined, undefined, { loading: { loading: true } });


// WEBPACK FOOTER //
// ./app/features/selectores/items/municipio/index.tsx